import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotificationLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 19C15 20.0544 14.1841 20.9182 13.1493 20.9945L13 21H11C9.94564 21 9.08183 20.1841 9.00548 19.1493L9 19H15ZM12.0002 2C15.7857 2 18.8693 5.00479 18.9961 8.75935L19.0002 9V12.7639L20.8222 16.4081C21.1705 17.1047 20.7047 17.9183 19.9532 17.9943L19.8384 18H4.16197C3.38319 18 2.8637 17.2195 3.13189 16.5134L3.1781 16.4081L5.00016 12.7639V9C5.00016 5.13401 8.13417 2 12.0002 2ZM12.0002 4C9.31141 4 7.11834 6.12231 7.00478 8.78311L7.00016 9V12.7639C7.00016 13.0123 6.95389 13.2579 6.86429 13.4885L6.78902 13.6584L5.6182 16H18.3821L17.2113 13.6584C17.1003 13.4362 17.0318 13.1957 17.0088 12.9495L17.0002 12.7639V9C17.0002 6.23858 14.7616 4 12.0002 4Z"
	})
});
export default SvgNotificationLine;
